module.exports = __webpack_public_path__ + "img/de.5d956124.png";